import { Link } from 'react-router-dom';
import type { Novel } from '@/mocks/novels';

interface NovelCardProps {
  novel: Novel;
}

export default function NovelCard({ novel }: NovelCardProps) {
  return (
    <Link
      to={`/article/${novel.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer"
    >
      <div className="aspect-[3/4] overflow-hidden">
        <img
          src={novel.coverImage}
          alt={novel.title}
          title={`${novel.title} - 可爱小说推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {novel.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{novel.author}</p>
        <div className="flex items-center gap-1.5 mt-2">
          <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-800">
            {novel.category}
          </span>
          <span className="text-xs text-foreground-400">{novel.wordCount}</span>
        </div>
        <div className="flex items-center gap-1 mt-2">
          <i className="ri-star-fill text-amber-400 text-xs"></i>
          <span className="text-xs font-medium text-foreground-800">{novel.rating}</span>
          <span className="text-xs text-foreground-400 ml-auto">{novel.status}</span>
        </div>
      </div>
    </Link>
  );
}